<template>
    <div class="content content-page bookmark">
        <div class="container">
            <div class="row">

                <projectsidebarpostulante></projectsidebarpostulante>

                <div class="col-xl-9 col-lg-8">
                    <div class="dashboard-sec payout-section freelancer-statements">
                        <div class="page-title portfolio-title">
                            <h3 class="mb-0">Educacion</h3>
                        </div>

                        <form @submit.prevent="updateEducationExpLabLanguages">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="input-block">
                                        <label class="form-label">¿Tienes los estudios secundarios completos?</label>
                                        <div class="check-radio">
                                        <ul style="display:flex">
                                            <li>
                                                <label class="custom_radio me-4">
                                                    <input type="radio" name="budget" v-model="schoolCompleted" value="SI"/>
                                                    <span class="checkmark border-agv"></span> SI
                                                </label>
                                            </li>
                                            <li>
                                                <label class="custom_radio me-4">
                                                    <input type="radio" name="budget" v-model="schoolCompleted" value="NO"/>
                                                    <span class="checkmark border-agv"></span> NO
                                                </label>
                                            </li>
                                        </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Educacion -->
                            <div class="row">
                            <div class="col-md-12">
                                <h4>Educacion</h4>
                            </div>
                            <div class="col-md-6 col-lg-2">
                                <div class="input-block">
                                <label class="focus-label">Grado</label>
                                <vue-select :options="academicDegree" v-model="newEducation.degree" placeholder="Selecionar" />
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-5">
                                <div class="input-block">
                                <label class="focus-label">Instituto/Universidad</label>
                                <input type="text" v-model="newEducation.university" class="form-control" />
                                <!-- <vue-select :options="universities" v-model="newEducation.university" placeholder="Select" /> -->
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-5">
                                <div class="input-block">
                                <label class="focus-label">Carrera</label>
                                <input type="text" v-model="newEducation.career" class="form-control" />
                                </div>
                            </div>
                            <!-- <div class="col-md-6 col-lg-3">
                                <div class="input-block">
                                <label class="focus-label">Descripcion</label>
                                <input type="text" v-model="newEducation.description" class="form-control" />
                                </div>
                            </div> -->
                            <div class="col-md-6 col-lg-3">
                                <div class="input-block">
                                <label class="focus-label">Fecha Inicio</label>
                                <div class="cal-icon">
                                    <datepicker v-model="newEducation.start_date" placeholder="Elegir fecha" class="form-control datetimepicker" :editable="true" :clearable="false" />
                                </div>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-3">
                                <div class="input-block">
                                <label class="focus-label">Fecha Fin</label>
                                <div class="cal-icon">
                                    <datepicker v-model="newEducation.end_date" placeholder="Elegir fecha" class="form-control datetimepicker" :editable="true" :clearable="false"/>
                                </div>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-3" style="margin-top:35px;">
                                <div class="input-block min-characters">
                                <label class="custom_check" style="padding-top:5px">
                                    <input 
                                    type="checkbox" 
                                    name="select_time" 
                                    value="SI" 
                                    v-model="newEducation.actuallyStudying" 
                                    />
                                    <span
                                    class="checkmark border-agv"
                                    ></span>
                                    Actualidad
                                </label>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-3" style="margin-top:30px; text-align:center;">
                                <div class="input-block min-characters">
                                <div class="new-addd">
                                    <a class="add-new text-success" @click="addEducation"><i class="feather-plus-circle me-1"></i> Agregar Nuevo</a>
                                </div>
                                </div>
                            </div>
                            </div>

                            <div id="education_add_row">
                                <div class="row" v-for="(education, index) in educations" :key="index">
                                    <div class="col-md-12">
                                    <h4>Educacion</h4>
                                    </div>
                                    <div class="col-md-6 col-lg-2">
                                    <div class="input-block">
                                        <label class="focus-label">Grado</label>
                                        <vue-select :options="academicDegree" v-model="education.degree" placeholder="Select" />
                                    </div>
                                    </div>
                                    <div class="col-md-6 col-lg-5">
                                    <div class="input-block">
                                        <label class="focus-label">Instituto/Universidad</label>
                                        <input type="text" v-model="education.university" class="form-control" />
                                    </div>
                                    </div>
                                    <div class="col-md-6 col-lg-5">
                                    <div class="input-block">
                                        <label class="focus-label">Carrera</label>
                                        <input type="text" v-model="education.career" class="form-control" />
                                    </div>
                                    </div>
                                    <div class="col-md-6 col-lg-3">
                                    <div class="input-block">
                                        <label class="focus-label">Fecha Inicio</label>
                                        <div class="cal-icon">
                                        <datepicker v-model="education.start_date" placeholder="Choose Date" class="form-control datetimepicker" :editable="true" :clearable="false" />
                                        </div>
                                    </div>
                                    </div>
                                    <div class="col-md-6 col-lg-3">
                                    <div class="input-block">
                                        <label class="focus-label">Fecha Fin</label>
                                        <div class="cal-icon">
                                        <datepicker v-model="education.end_date" placeholder="Choose Date" class="form-control datetimepicker" :editable="true" :clearable="false" />
                                        </div>
                                    </div>
                                    </div>
                                    <div class="col-md-6 col-lg-3" style="margin-top:35px;">
                                    <div class="input-block min-characters">
                                        <label class="custom_check" style="padding-top:5px">
                                        <input 
                                        type="checkbox" 
                                        name="select_time" 
                                        value="SI" 
                                        v-model="education.actuallyStudying" 
                                        />
                                        <span
                                            class="checkmark border-agv"
                                        ></span>
                                        Actualidad
                                        </label>
                                    </div>
                                    </div>
                                    <div class="col-md-6 col-lg-3" style="margin-top:30px; text-align:center;">
                                    <div class="input-block min-characters">
                                        <div class="new-addd">
                                        <a @click="deleteEducation(index)" class="text-danger" style="cursor:pointer"><i class="feather-minus-circle me-1"></i>Eliminar</a>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                    
                            <!-- Experiencia Laboral -->
                            <div class="row mt-3">
                                <div class="col-md-12">
                                    <h4>Experiencia Laboral</h4>
                                </div>
                                <div class="col-md-6 col-lg-6">
                                    <div class="input-block">
                                    <label class="focus-label">Nombre de Empresa</label>
                                    <input type="text" v-model="newExperience.company" class="form-control" />
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-6">
                                    <div class="input-block">
                                    <label class="focus-label">Cargo</label>
                                    <input type="text" v-model="newExperience.work_pos" class="form-control" />
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-2">
                                    <div class="input-block">
                                    <label class="focus-label">Sueldo</label>
                                    <input type="text" v-model="newExperience.mount" class="form-control" />
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-4">
                                    <div class="input-block">
                                    <label class="focus-label">Descripcion</label>
                                    <input type="text" v-model="newExperience.description" class="form-control" />
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-2">
                                    <div class="input-block">
                                    <label class="focus-label">Fecha Inicio</label>
                                    <div class="cal-icon">
                                        <datepicker v-model="newExperience.start_date" placeholder="Elegir Fecha" class="form-control datetimepicker" :editable="true" :clearable="false" />
                                    </div>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-2">
                                    <div class="input-block">
                                    <label class="focus-label">Fecha Fin</label>
                                    <div class="cal-icon">
                                        <datepicker v-model="newExperience.end_date" placeholder="Elegir Fecha" class="form-control datetimepicker" :editable="true" :clearable="false" />
                                    </div>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-2" style="margin-top:35px;">
                                    <div class="input-block min-characters">
                                    <label class="custom_check" style="padding-top:5px">
                                        <input 
                                        type="checkbox" 
                                        name="select_time" 
                                        value="SI" 
                                        v-model="newExperience.actuallyWorking" 
                                        />
                                        <span
                                        class="checkmark border-agv"
                                        ></span>
                                        Actualidad
                                    </label>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-3">
                                    <div class="input-block">
                                    <label class="focus-label">Nombre del Contacto</label>
                                    <input type="text" v-model="newExperience.name_contact" class="form-control" />
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-3">
                                    <div class="input-block">
                                    <label class="focus-label">Cargo del Contacto</label>
                                    <input type="text" v-model="newExperience.work_pos_contact" class="form-control" />
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-3">
                                    <div class="input-block">
                                    <label class="focus-label">Celular del Contacto</label>
                                    <input type="text" v-model="newExperience.phone_contact" class="form-control" />
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-3">
                                    <div class="input-block">
                                    <label class="focus-label">Correo del Contacto</label>
                                    <input type="text" v-model="newExperience.email_contact" class="form-control" />
                                    <div class="new-addd">
                                        <a class="add-new text-success" @click="addExperience"><i class="feather-plus-circle me-1"></i> Agregar Nuevo</a>
                                    </div>
                                    </div>
                                </div>
                            </div>

                            <div v-for="(experience, index) in experiences" :key="index" class="row">
                                <div class="col-md-6 col-lg-6">
                                    <div class="input-block">
                                    <label class="focus-label">Nombre de Empresa</label>
                                    <input type="text" v-model="experience.company" class="form-control" />
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-6">
                                    <div class="input-block">
                                    <label class="focus-label">Cargo</label>
                                    <input type="text" v-model="experience.work_pos" class="form-control" />
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-2">
                                    <div class="input-block">
                                    <label class="focus-label">Sueldo</label>
                                    <input type="text" v-model="experience.mount" class="form-control" />
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-4">
                                    <div class="input-block">
                                    <label class="focus-label">Descripcion</label>
                                    <input type="text" v-model="experience.description" class="form-control" />
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-2">
                                    <div class="input-block">
                                    <label class="focus-label">Fecha Inicio</label>
                                    <div class="cal-icon">
                                        <datepicker v-model="experience.start_date" placeholder="Elegir Fecha" class="form-control datetimepicker" :editable="true" :clearable="false" />
                                    </div>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-2">
                                    <div class="input-block">
                                    <label class="focus-label">Fecha Fin</label>
                                    <div class="cal-icon">
                                        <datepicker v-model="experience.end_date" placeholder="Elegir Fecha" class="form-control datetimepicker" :editable="true" :clearable="false" />
                                    </div>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-2" style="margin-top:35px;">
                                    <div class="input-block min-characters">
                                    <label class="custom_check" style="padding-top:5px">
                                        <input 
                                        type="checkbox" 
                                        name="select_time" 
                                        value="SI" 
                                        v-model="experience.actuallyWorking" 
                                        />
                                        <span
                                        class="checkmark border-agv"
                                        ></span>
                                        Actualidad
                                    </label>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-3">
                                    <div class="input-block">
                                    <label class="focus-label">Nombre del Referente</label>
                                    <input type="text" v-model="experience.name_contact" class="form-control" />
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-3">
                                    <div class="input-block">
                                    <label class="focus-label">Cargo del Referente</label>
                                    <input type="text" v-model="experience.work_pos_contact" class="form-control" />
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-3">
                                    <div class="input-block">
                                    <label class="focus-label">Celular del Referente</label>
                                    <input type="text" v-model="experience.phone_contact" class="form-control" />
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-3">
                                    <div class="input-block">
                                    <label class="focus-label">Correo del Referente</label>
                                    <input type="text" v-model="experience.email_contact" class="form-control" />
                                    <div class="new-addd">
                                        <a class="remove_row" @click="deleteExperience(index)"><i class="feather-minus-circle me-1"></i>Eliminar</a>
                                    </div>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Idiomas -->
                            <div class="row">
                                <div class="col-md-12">
                                    <h4>Idiomas</h4>
                                </div>
                                <div class="col-md-6 col-lg-4">
                                    <div class="input-block">
                                    <label class="focus-label">Lenguaje</label>
                                    <input type="text" v-model="newLanguage.name" class="form-control" />
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-4">
                                    <div class="input-block">
                                    <label class="focus-label">Nivel</label>
                                    <vue-select :options="levelLenguage" v-model="newLanguage.level" placeholder="Seleccionar" />
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-4" style="margin-top:30px;">
                                    <div class="new-addd">
                                    <a class="add-new text-success" @click="addLanguage"><i class="feather-plus-circle me-1"></i> Agregar Nuevo</a>
                                    </div>
                                </div>
                                </div>
                                <div v-for="(language, index) in languages" :key="index" class="row">
                                <div class="col-md-6 col-lg-4">
                                    <div class="input-block">
                                    <label class="focus-label">Lenguaje</label>
                                    <input type="text" v-model="language.name" class="form-control" />
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-4">
                                    <div class="input-block">
                                    <label class="focus-label">Nivel</label>
                                    <vue-select :options="levelLenguage" v-model="language.level" placeholder="Seleccionar" />
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-4" style="margin-top:30px;">
                                    <div class="new-addd">
                                    <a class="remove_row" @click="deleteLanguage(index)"><i class="feather-minus-circle me-1"></i>Eliminar</a>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <div class="input-block">
                                        <label class="form-label">Cargar Nuevo CV</label>
                                        <div class="upload-sets">
                                            <label class="upload-filesview">
                                                Buscar archivo
                                                <input type="file" @change="handleFileUpload" accept=".pdf,.docx" style="cursor:pointer;"/>
                                            </label>
                                        </div>
                                        <span v-if="fileCvApplicantName" class="file-name text-success text-center" style="width:100%">{{ fileCvApplicantName }}</span>
                                    </div>
                                    <span>
                                        (Los formatos permitidos son .pdf, .docx)
                                    </span>
                                </div>
                            </div>

                            <div class="row mt-5">
                                <div class="col-md-4"></div>
                                <div class="col-md-4">
                                    <button class="btn btn-primary pt-1" type="submit" style="width:100%; padding-top:30px; padding-bottom:10px;">Actualizar Datos</button>
                                </div>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Pie de Página -->
    <footeragv></footeragv>
</template>

<script>
import axiosIns from '@/plugins/axios.js';
import { ref } from "vue";
import { Form, Field } from "vee-validate";
export default {
    components: {
        Form,
        Field,
    },
    data() {
        return {
            id_applicant: JSON.parse(localStorage.getItem('userData'))?.id_usuario,
            
            showPassword: false,
            password: null,
            emailError: "",
            passwordError: "",
            currentStep: 1,
            totalSteps: 4,
            
            username: null,
            email: null,
            password: null,

            name: null,
            firstSurname: null,
            secondSurname: null,
            selectedTypeDoc: null,
            typeDocs: ["C.E.","DNI","PASAPORTE"],
            n_doc: null,
            phone: null,
            birthdate: null,
            selectedGender: null,
            genders: ["Masculino","Femenino"],
            selectedMaritalStatus : null,
            maritalStatus : ["Soltero","Casado","Divorciado","Conviviente"],
            nationality: null,
            country: null,
            departament: null,
            province: null,
            district: null,
            salary_expect: null,
            personalDescription: null,
            availabTravel: 'NO',
            availabChangeResid: 'NO',
            driversLicense: 'NO',
            disability: 'NO',

            schoolCompleted: null,

            levelLenguage: ["Basico", "Intermedio", "Avanzado"],
            academicDegree: ["Tecnico", "Universitario","Maestria","Doctorado"],
            socialNetworks: ["Linkedin", "Facebook", "Instagram", "Tik Tok"],
            schoolCompleted: "",
            newEducation: {
                degree: "",
                university: "",
                career: "",
                start_date: "",
                end_date: "",
                present: false,
            },
            educations: [],
            newExperience: {
                company: "",
                work_pos: "",
                mount: "",
                description: "",
                start_date: "",
                end_date: "",
                present: false,
                name_contact:"",
                work_pos_contact:"",
                phone_contact:"",
                email_contact:"",
            },
            experiences: [],
            newLanguage: {
                name: "",
                level: ""
            },
            languages: [],
            
            fileCvApplicant:null,
            fileCvApplicantName:null,
            imgApplicant:null,
            imgPreviewApplicant:null,
            bumeranInvitation: false,
            termsAccepted: 'NO',

            educations_before_edit : [],
            experiences_before_edit : [],
            languages_before_edit : [],

            // startdate: currentDate,
        };
    },

    mounted(){
        this.getApplicant()
    },

    methods: {

        getApplicant(){

            const yo = this
            const data = JSON.stringify({
                id : yo.id_applicant,
            })

            const config = {
                method: 'post',
                url: '/talentoagv/getApplicantEducationWorkExpLang/',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data,
            }

            axiosIns(config)
                .then(function (response) {
                    console.log(response)
                    if (response.data['is_error'] === false){
                        
                        let educacionUsuario = response.data['result'][0]
                        let expLabUsuario = response.data['result'][1]
                        let lenguajesUsuario = response.data['result'][2]
                        // console.log(educacionUsuario)
                        // console.log(expLabUsuario)
                        // console.log(lenguajesUsuario)
                        yo.educations = educacionUsuario
                        yo.experiences = expLabUsuario
                        yo.languages = lenguajesUsuario

                        // Guardar los valores originales antes de editar
                        yo.educations_before_edit = JSON.parse(JSON.stringify(educacionUsuario));
                        yo.experiences_before_edit = JSON.parse(JSON.stringify(expLabUsuario));
                        yo.languages_before_edit = JSON.parse(JSON.stringify(lenguajesUsuario));

                        // yo.educations_before_edit = educacionUsuario
                        // yo.experiences_before_edit = expLabUsuario
                        // yo.languages_before_edit = lenguajesUsuario

                    }
            })
            .catch(function (error) {
                console.log(error);
                // yo.$toastr.error(response.data['message'], 'Error')
            })
            .finally(function (){

            })

        },
        
        updateEducationExpLabLanguages(){

            // Añadir la nueva educación si no está vacía
            if (this.newEducation.degree || this.newEducation.university || this.newEducation.start_date || this.newEducation.end_date) {
                this.educations.push({ ...this.newEducation });
            }

            // Añadir la nueva experiencia si no está vacía
            if (this.newExperience.company || this.newExperience.work_pos || this.newExperience.start_date || this.newExperience.end_date) {
                this.experiences.push({ ...this.newExperience });
            }

            // Añadir el nuevo idioma si no está vacío
            if (this.newLanguage.name || this.newLanguage.level) {
                this.languages.push({ ...this.newLanguage });
            }
            
            const yo = this
            console.log("AAA")
            console.log(yo.languages)
            console.log("BBB")
            console.log(yo.languages_before_edit)
            const data = JSON.stringify({
                id: yo.id_applicant,
                educations : yo.educations,
                experiences : yo.experiences,
                languages :yo.languages,
    
                educations_before_edit: yo.educations_before_edit,
                experiences_before_edit : yo.experiences_before_edit,
                languages_before_edit: yo.languages_before_edit,

                block : 'edu_exp_lab',
            })

            const config = {
                method: 'post',
                url: '/talentoagv/updateApplicant/',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data,
            }

            axiosIns(config)
                .then(function (response) {
                    // if (response.data['is_error'] === false){
                    //     yo.$toastr.success('Usuario actualizado', 'Exito')
                    // }
                })
                .catch(function (error) {
                    console.log(error);
                })
                .finally(function (){
                    yo.newEducation = {
                        degree: "",
                        university: "",
                        career: "",
                        start_date: "",
                        end_date: "",
                        present: false,
                    },
                    yo.newExperience = {
                        company: "",
                        work_pos: "",
                        mount: "",
                        description: "",
                        start_date: "",
                        end_date: "",
                        present: false,
                        name_contact:"",
                        work_pos_contact:"",
                        phone_contact:"",
                        email_contact:"",
                    }
                    yo.newLanguage = { 
                        name: "", level: "" 
                    };
                })

        },

        handlePhotoChangeApplicant(event) {
            const file = event.target.files[0];
            if (file) {
                this.imgApplicant = file;
                this.imgPreviewApplicant= URL.createObjectURL(file);
            }
        },

        handleFileUpload(event) {
            const file = event.target.files[0];
            if (file) {
                this.fileCvApplicant = file;
                this.fileCvApplicantName = file.name;
            } else {
                this.fileCvApplicant = '';
            }
        },

        addEducation() {
            this.educations.push({ ...this.newEducation });
            this.newEducation = { 
                degree: "", 
                university: "", 
                career: "", 
                start_date: "", 
                end_date: "", 
                present: false,
            };
        },
        deleteEducation(index) {
            this.educations.splice(index, 1);
        },
        addExperience() {
            this.experiences.push({ ...this.newExperience });
            this.newExperience = { 
                company: "", 
                work_pos: "", 
                mount: "", 
                description: "", 
                start_date: "", 
                end_date: "", 
                actuallyWorking:"NO",
                name_contact:"",
                work_pos_contact:"",
                phone_contact:"",
                email_contact:"",
            };
        },
        deleteExperience(index) {
            this.experiences.splice(index, 1);
        },
        addLanguage() {
            this.languages.push({ ...this.newLanguage });
            this.newLanguage = { name: "", level: "" };
        },
        deleteLanguage(index) {
            this.languages.splice(index, 1);
        }

    }
}

</script>